(function () {
  const ROOT_SELECTOR = '[data-market-selector]';
  const DRAWER_SELECTOR = '[data-market-selector-drawer]';
  const OPEN_SELECTOR = '[data-market-selector-open]';
  const CLOSE_SELECTOR = '[data-market-selector-close]';
  const APPLY_SELECTOR = '[data-market-apply]';
  const DESKTOP_MQ = window.matchMedia('(min-width: 1025px)');

  const MARKET_LOCALES_FALLBACK = {
    US: [{ locale: 'en', label: 'English' }],
    CA: [
      { locale: 'en', label: 'English' },
      { locale: 'fr', label: 'Français' }
    ],
    MX: [{ locale: 'es', label: 'Español' }],
    FR: [
      { locale: 'fr', label: 'Français' },
      { locale: 'en', label: 'English' }
    ],
    DE: [
      { locale: 'de', label: 'Deutsch' },
      { locale: 'en', label: 'English' }
    ],
    ES: [
      { locale: 'es', label: 'Español' },
      { locale: 'en', label: 'English' }
    ],
    IT: [
      { locale: 'it', label: 'Italiano' },
      { locale: 'en', label: 'English' }
    ],
    AU: [{ locale: 'en', label: 'English' }],
    SG: [{ locale: 'en', label: 'English' }],
    KR: [{ locale: 'ko', label: '한국어' }],
    JP: [{ locale: 'ja', label: '日本語' }],
    EU_OTHER: [{ locale: 'en', label: 'English', countryCode: 'DE' }]
  };

  const EU_PRIMARY = new Set(['FR', 'DE', 'IT', 'ES']);
  const EU_FALLBACK = new Set([
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'GR', 'HU', 'IE',
    'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'CH'
  ]);

  function getMarketLocales() {
    const configEl = document.querySelector('.market-selector-config');
    if (!configEl) return MARKET_LOCALES_FALLBACK;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      return MARKET_LOCALES_FALLBACK;
    }
  }

  let marketLocalesCache;
  function getLocalesForCountry(countryCode) {
    if (!marketLocalesCache) marketLocalesCache = getMarketLocales();
    return marketLocalesCache[countryCode] || null;
  }

  function resolveDetectedMarket(countryCode) {
    if (!countryCode) return null;
    if (getLocalesForCountry(countryCode)) return countryCode;
    if (EU_PRIMARY.has(countryCode)) return countryCode;
    if (EU_FALLBACK.has(countryCode) && getLocalesForCountry('EU_OTHER')) return 'EU_OTHER';
    return null;
  }

  function getFormFromTrigger(trigger) {
    if (!trigger) return null;
    const formId = trigger.getAttribute('form');
    if (formId) return document.getElementById(formId);
    return trigger.closest('.market-selector__form');
  }

  function applyMarket(form, countryCode, localeCode) {
    if (!form || !countryCode || !localeCode) return;

    const countryInput = form.querySelector('[data-market-country-input]');
    const localeInput = form.querySelector('[data-market-locale-input]');
    if (!countryInput || !localeInput) return;

    countryInput.value = countryCode;
    localeInput.value = localeCode;
    form.submit();
  }

  function getModalId(trigger) {
    return trigger.getAttribute('aria-controls') || trigger.dataset.marketSelectorTarget;
  }

  function openModal(modal) {
    if (!modal || modal.classList.contains('is--open')) return;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('t4s-lock-scroll');
    window.requestAnimationFrame(() => {
      modal.classList.add('is--open');
    });

    const closeBtn = modal.querySelector('.market-selector__close');
    if (closeBtn) closeBtn.focus();

    loadDetectedCountry(modal);
  }

  function closeModal(modal) {
    if (!modal || !modal.classList.contains('is--open')) return;

    modal.classList.remove('is--open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('t4s-lock-scroll');

    window.setTimeout(() => {
      if (!modal.classList.contains('is--open')) {
        modal.hidden = true;
      }
    }, 260);
  }

  function bindApplyHandlers(root) {
    if (!root || root.dataset.marketApplyBound === 'true') return;
    root.dataset.marketApplyBound = 'true';

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest(APPLY_SELECTOR);
      if (!trigger) return;

      const form = getFormFromTrigger(trigger);
      const countryCode = trigger.dataset.countryCode;
      const localeCode = trigger.dataset.localeCode;
      if (!form || !countryCode || !localeCode) return;

      event.preventDefault();
      applyMarket(form, countryCode, localeCode);
    });
  }

  function renderDetectedActions(container, form, marketKey, detectedCode) {
    if (!container || !form) return;

    const locales = getLocalesForCountry(marketKey);
    container.innerHTML = '';

    if (!locales || !locales.length) {
      container.hidden = true;
      return;
    }

    locales.forEach((entry) => {
      const button = document.createElement('button');
      const submitCountry = marketKey === 'EU_OTHER' && detectedCode ? detectedCode : entry.countryCode || detectedCode || marketKey;
      button.type = 'button';
      button.className = 'market-selector__lang market-selector__lang--footer';
      button.dataset.marketApply = '';
      button.dataset.countryCode = submitCountry;
      button.dataset.localeCode = entry.locale;
      button.textContent = entry.label;
      container.appendChild(button);
    });

    container.hidden = false;
  }

  function updateDetectedEuFallback(root, marketKey, detectedCode) {
    if (!root || marketKey !== 'EU_OTHER' || !detectedCode) return;

    root.querySelectorAll('[data-market-key="EU_OTHER"] [data-market-apply]').forEach((button) => {
      button.dataset.countryCode = detectedCode;
    });
  }

  function loadDetectedCountry(root) {
    const footer = root.querySelector('[data-market-selector-footer]');
    const nameEl = root.querySelector('[data-market-detected-name]');
    const actionsEl = root.querySelector('[data-market-detected-actions]');
    const currentCode = (root.dataset.currentCountry || '').toUpperCase();
    const form = root.querySelector('.market-selector__form');

    if (!footer || !nameEl || !actionsEl || !currentCode || !form) return;

    nameEl.textContent = '';
    actionsEl.hidden = true;
    actionsEl.innerHTML = '';

    const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const url = `${rootUrl}browsing_context_suggestions.json?country[enabled]=true`;

    fetch(url, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data || !data.detected_values || !data.detected_values.country) return;

        const detected = data.detected_values.country;
        const detectedCode = (detected.iso_code || detected.handle || '').toUpperCase();
        const detectedName = detected.name || detectedCode;

        if (!detectedName) return;

        nameEl.textContent = detectedName;

        if (!detectedCode || detectedCode === currentCode) return;

        const marketKey = resolveDetectedMarket(detectedCode);
        if (!marketKey) return;

        updateDetectedEuFallback(root, marketKey, detectedCode);
        renderDetectedActions(actionsEl, form, marketKey, detectedCode);
      })
      .catch(() => {});
  }

  function bindModal(modal) {
    if (!modal || modal.dataset.marketSelectorBound === 'true') return;
    modal.dataset.marketSelectorBound = 'true';

    bindApplyHandlers(modal);

    modal.querySelectorAll(CLOSE_SELECTOR).forEach((el) => {
      el.addEventListener('click', () => closeModal(modal));
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(modal);
      }
    });

    loadDetectedCountry(modal);
  }

  function bindDrawer(drawer) {
    if (!drawer || drawer.dataset.marketSelectorBound === 'true') return;
    drawer.dataset.marketSelectorBound = 'true';

    bindApplyHandlers(drawer);
    loadDetectedCountry(drawer);
  }

  function initMarketSelector() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bindModal);
    document.querySelectorAll(DRAWER_SELECTOR).forEach(bindDrawer);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(OPEN_SELECTOR);
      if (!trigger) return;
      if (!DESKTOP_MQ.matches) return;

      const modalId = getModalId(trigger);
      const modal = modalId ? document.getElementById(modalId) : document.querySelector(ROOT_SELECTOR);
      if (!modal) return;

      event.preventDefault();
      openModal(modal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarketSelector);
  } else {
    initMarketSelector();
  }
})();
